import { useFormContext, useWatch } from 'react-hook-form';
import { useDisclosure } from '@ds';
import { AdminFormRow, ConfirmationModal } from '@ui';
import { EmployeeFormValues } from '@/types';
import { ControlledYesNoRadio } from './ControlledYesNoRadio';

interface ActiveAccountInputProps {
  isReadOnly?: boolean;
  isContractor?: boolean;
}

export const ActiveAccountInput = ({ isReadOnly, isContractor }: ActiveAccountInputProps) => {
  const { control, setValue } = useFormContext<EmployeeFormValues>();
  const isActive = useWatch({ control, name: 'isActive' });
  const { isOpen, onOpen, onClose } = useDisclosure();

  const modalTitle = isContractor ? 'Change Contractor active status' : 'Change Employee active status';

  const onChangeActive = async () => {
    setValue('isActive', !isActive, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <>
      <AdminFormRow title="Active account" isRequired>
        <ControlledYesNoRadio name="isActive" isReadOnly={isReadOnly} onValueChange={onOpen} />
      </AdminFormRow>
      <ConfirmationModal
        title={modalTitle}
        description="Are you sure you want to change the active status?"
        isOpen={isOpen}
        onChangeActive={onChangeActive}
        onClose={onClose}
      />
    </>
  );
};
